export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/ask_leave/my',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '请假',
    apis: [{
      path: '/basis/ask_leave',
      method: 'POST'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/basis/ask_leave/{id}',
      method: 'PUT'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/basis/ask_leave/{id}',
      method: 'DELETE'
    }]
  },
  data_file: {
    funKey: 'data_file',
    name: '附件'
  },
  getDataFile: {
    funKey: 'getDataFile',
    name: '获取附件'
  },
  updateDataFile: {
    funKey: 'updateDataFile',
    name: '上传附件'
  },
  downDataFile: {
    funKey: 'downDataFile',
    name: '下载附件'
  },
  delDataFile: {
    funKey: 'delDataFile',
    name: '删除附件'
  }
}
